<template>
    <div>
        <loader-component v-if="isSendingDataToServer"></loader-component>
        <loader-component v-if="showLoader"></loader-component>
        <div v-else class="wrapper default shopping-page">


            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar-component></navbar-component>
            </header>

            <main class="cart-page default">
                <div class="container">
                    <div class="row">

                        <div class="cart-page-content col-xl-12 col-lg-12 col-md-12 ">
                            <div class="row">
                                <div class="info-main-top col-xl-6 col-lg-6 col-md-6 col-xs-12">
                                    <span class="title">شماره سفارش : </span>
                                    <span class="text"> {{order.InvoiceNo}} </span>
                                </div>
                                <div class="info-main-top col-xl-6 col-lg-6 col-md-6 col-xs-12">
                                    <span class="title"> تاریخ و زمان ثبت : </span>
                                    <span class="text"> {{order.OrderRegDateTime}} </span>
                                </div>
                            </div>

                            <section v-if="order.OrderTypeId == 2 &&  order.LastOrderStatusTypeId != 3 " class="page-content tracking default col-xl-12 col-lg-12 col-md-12">
                                <div class="content-p col-xl-12 col-lg-12 col-md-12">
                                    <div class="title-showInvoice  col-md-4">
                                        <p class="title">وضیعت سفارش پرداختی ها</p>
                                    </div>
                                    <ul>
                                        <li :class="['step1','left-l',(order.CollaegueOrderStatusTypeId >= 1)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title"> بررسی سفارش </span>
                                        </li>
                                        <li :class="['progress',(order.CollaegueOrderStatusTypeId >= 2)? 'done':'']"></li>
                                        <li :class="['step1','left-l',(order.CollaegueOrderStatusTypeId >= 2)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">در انتظارتأیید اطلاعات پرداختی</span>
                                        </li>
                                        <li :class="['progress',(order.CollaegueOrderStatusTypeId >= 2)? 'done':'']"></li>
                                        <li :class="['step1','left-l',(order.CollaegueOrderStatusTypeId >= 3)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تأیید اطلاعات پرداختی</span>
                                        </li>

                                    </ul>
                                </div>
                            </section>
                            <hr />
                            <section class="page-content tracking default col-xl-12 col-lg-12 col-md-12">
                                <div class="content-p col-xl-12 col-lg-12 col-md-12">
                                    <div style="margin-top:30px" class="title-showInvoice  col-md-4">
                                        <p class="title">وضیعت سفارش</p>
                                    </div>
                                    <ul v-if="order.LastOrderStatusTypeId != 3">
                                        <li v-if="order.OrderTypeId != 2" :class="['step1','left-l',(order.LastOrderStatusTypeId >= 1)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">بررسی سفارش</span>
                                        </li>
                                        <li v-if="order.OrderTypeId != 2" :class="['progress',(order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                        </li>
                                        <li :class="['step2','right-r',(order.LastOrderStatusTypeId >= 2)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تایید سفارش</span>
                                        </li>
                                        <li :class="['progress','left-l',(order.LastOrderStatusTypeId >= 4)? 'done':'']">
                                        </li>
                                        <li :class="['step4','left-l',(order.LastOrderStatusTypeId >= 4)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تحویل به پیک</span>
                                        </li>
                                        <li :class="['progress',(order.LastOrderStatusTypeId >= 5)? 'done':'']">
                                        </li>
                                        <li :class="['step3','right-r',(order.LastOrderStatusTypeId >= 5)? 'done':'']">
                                            <span class="icon"></span>
                                            <span class="title">تحویل به مشتری</span>
                                        </li>

                                    </ul>
                                    <ul v-else>
                                        <li style="width:100%">
                                            <div class="warning-checkout text-center default col-xl-12 col-lg-12 col-md-12">
                                                <div class="icon-warning">
                                                    <img src="/assets/img/step/rejectOrder.svg" alt="سفارش شما توسط فروشگاه رد شده است" title="سفارش شما توسط فروشگاه رد شده است" />
                                                </div>
                                                <h1>سفارش شما توسط فروشگاه رد شده است.</h1>
                                                <p></p>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="preparreduration-main" v-if="order.PrepareDuration != null && order.LastOrderStatusTypeId != 5 && order.LastOrderStatusTypeId != 1">
                                        <div class="content"><span class="title">زمان تقریبی تحویل سفارش :</span> <span> {{order.PrepareDuration}}</span> <span> روز</span></div>
                                    </div>
                                    <div class="preparreduration-main" v-if="order.LastOrderStatusTypeId == 1">
                                        <div class="content"><span class="title">سفارش ثبت و در حال بررسی می باشد.</span></div>
                                    </div>
                                    <div class="preparreduration-main" v-if="order.LastOrderStatusTypeId == 5">
                                        <div class="content"><span class="title">سفارش شما تحویل داده شده است.</span></div>
                                    </div>
                                </div>
                            </section>
                            <section class="table-content col-xl-12 col-lg-12 col-md-12">
                                <div class="toman"><i class="now-ui-icons travel_info"></i> <span class="alarm"> توجه : </span> <span>  قیمت ها به ریال می باشد.</span></div>
                                <div class="table-responsive">
                                    <table class="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th scope="col">ردیف</th>
                                                <th scope="col">نام محصول</th>
                                                <th scope="col">واحد</th>
                                                <th scope="col">تعداد / مقدار</th>
                                                <th scope="col">نوع پرداخت</th>
                                                <th scope="col">قیمت واحد</th>
                                                <th scope="col">قیمت کل</th>
                                                <th scope="col">مبلغ تخفیف</th>
                                                <th scope="col">قیمت نهایی</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(orderDetails ,index) in order.OrderDetails">
                                                <th scope="row">{{index + 1}}</th>
                                                <td>{{orderDetails.ProductName}}</td>
                                                <td>{{orderDetails.ProductUnit}}</td>
                                                <td>{{orderDetails.Quantity}}</td>
                                                <td>{{ orderDetails.PaymentTypeName}}</td>
                                                <td>{{orderDetails.Price | formatNumber}}</td>
                                                <td>{{orderDetails.Quantity * orderDetails.Price | formatNumber}}</td>
                                                <td>{{(orderDetails.Quantity * orderDetails.Price) - orderDetails.FinalPriceSum | formatNumber}}</td>
                                                <td>{{orderDetails.FinalPriceSum | formatNumber}}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </section>
                            <hr />
                            <section class="cart-summery col-xl-12 col-lg-12 col-md-12">
                                <div class="row main-cartsummery">
                                    <div class="col-lg-4 col-md-4">
                                        <div class="row">
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">تعداد محصول : </span>
                                                <span class="text"> {{order.CountOfProducts}} عدد</span>
                                            </div>

                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title"> هزینه ارسال : </span>
                                                <span class="text"> {{order.DeliveryFee | formatNumber }} ریال</span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  نحوه ارسال : </span>
                                                <span class="text"> {{order.CarrierName }} </span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  شماره تماس تحویل گیرنده : </span>
                                                <span class="text"> {{order.TransfereeMobNo }} </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-md-4">
                                        <div class="row">
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  مالیات بر ارزش افزوده : </span>
                                                <span class="text"> {{order.Tax | formatNumber }} ({{order.TaxRate}}%) ریال</span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title"> جمع مبلغ تخفیف : </span>
                                                <span class="text"> {{order.Discount | formatNumber }} ریال</span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  مبلغ کد تخفیف : </span>
                                                <span class="text"> {{order.CouponDiscount | formatNumber }} ریال</span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  جمع سود شما از تخفیف : </span>
                                                <span class="text"> {{order.Discount + order.CouponDiscount | formatNumber }} ریال</span>
                                            </div>


                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4">
                                        <div class="row">
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  جمع قابل پرداخت نقدی : </span>
                                                <span class="text"> {{order.CashPayableAmount| formatNumber }} ریال</span>
                                            </div>

                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title"> جمع قابل پرداخت چک : </span>
                                                <span class="text"> {{order.ChequePayableAmount | formatNumber }} ریال</span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title"> قیمت کل محصولات : </span>
                                                <span class="text"> {{order.SubTotal | formatNumber }} ریال</span>
                                            </div>
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  مبلغ قابل پرداخت : </span>
                                                <span class="text"> {{order.InvoiceDue | formatNumber }} ریال</span>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12">
                                        <div class="row">

                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">  آدرس محل تحویل : </span>
                                                <span class="text"> {{order.DeliveryAddress }} </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <hr />
                            <section class="cart-summery col-xl-12 col-lg-12 col-md-12">
                                <div class="row main-cartsummery">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="row">
                                            <div class="info-main-b col-xl-12 col-lg-12 col-md-12 col-xs-12">
                                                <span class="title">توضیحات ارسال : </span>
                                                <span class="text" v-text="order.PostalTrackingCode">  </span>
                                            </div>
                                        </div>
                                    </div>
 
                                </div>
                            </section>
                            <hr v-if="order.OrderTypeId == 2" />
                            <section v-if="order.OrderTypeId == 2" class="cach-cheque col-xl-12 col-lg-12 col-md-12">
                                <div class="row">
                                    <div v-if="order.CollaegueOrderStatusTypeId == 2" class="parent-btn">
                                        <button @click="openaddCashPaymentModal" class="dk-btn dk-btn-danger" type="button">
                                            پرداخت نقدی
                                            <i class="now-ui-icons ui-1_simple-add"></i>
                                        </button>
                                    </div>
                                    <div v-if="order.ColleagueOrderCachPayments != null && order.ColleagueOrderCachPayments.length > 0" class="table-responsive">
                                        <table class="table table-hover table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ردیف</th>
                                                    <th scope="col">شماره تراکنش</th>
                                                    <th scope="col">تاریخ واریز</th>
                                                    <th scope="col">مبلغ (ریال)</th>
                                                    <th scope="col">وضعیت</th>
                                                    <th scope="col">توضیحات فروشنده</th>
                                                    <th scope="col">عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(chashPayments ,index) in order.ColleagueOrderCachPayments">
                                                    <th scope="row">{{index + 1}}</th>
                                                    <td>{{chashPayments.TrackingNo}}</td>
                                                    <td>{{chashPayments.PaymentDate}}</td>
                                                    <td>{{chashPayments.Amount | formatNumber }}</td>
                                                    <td>{{chashPayments.IsConfirm}} </td>
                                                    <td>{{chashPayments.AdminComment}}</td>
                                                    <td width="250">
                                                        <button v-if="order.CollaegueOrderStatusTypeId == 2" @click="deleteCachPayment(chashPayments.Id , chashPayments.OrderId)" style="margin-top: 0; margin-left: 15px" class="btn btn-danger btn-sm btn-reject">حذف</button>
                                                        <button v-if="chashPayments.PicPath != null" @click="showPicPathOrderPayment(chashPayments.PicPath)" style="margin-top:0" class="btn btn-success btn-sm">مشاهده تصویر</button>
                                                    </td>

                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>
                            <hr v-if="order.OrderTypeId == 2" />
                            <section v-if="order.OrderTypeId == 2" class="cach-cheque col-xl-12 col-lg-12 col-md-12">
                                <div class="row">
                                    <div v-if="order.CollaegueOrderStatusTypeId == 2" class="parent-btn">
                                        <button @click="openaddChequePaymentModal" class="dk-btn dk-btn-danger" type="button">
                                            پرداخت چک
                                            <i class="now-ui-icons ui-1_simple-add"></i>
                                        </button>
                                    </div>

                                    <div v-if="order.ColleagueOrderChequePayments != null && order.ColleagueOrderChequePayments.length > 0" class="table-responsive">
                                        <table class="table table-hover table-striped">
                                            <thead>
                                                <tr>
                                                    <th scope="col">ردیف</th>
                                                    <!--<th scope="col">نام نام خانوادگی </th>-->
                                                    <th scope="col">کد ملی</th>
                                                    <th scope="col">کد صیادی</th>
                                                    <th scope="col">مبلغ (ریال)</th>
                                                    <th scope="col">تاریخ سر رسید</th>
                                                    <th scope="col">وضعیت</th>
                                                    <th scope="col">توضیحات فروشنده</th>
                                                    <th scope="col">عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(chequePayments ,index) in order.ColleagueOrderChequePayments">
                                                    <th :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}' scope="row">{{index + 1}}</th>
                                                    <td :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}'>{{chequePayments.ChequeHolderNationalCode}}</td>
                                                    <td :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}'>{{chequePayments.ChequeCode}}</td>
                                                    <td :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}'>{{chequePayments.Amount | formatNumber }}</td>
                                                    <td :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}'>{{chequePayments.DueDate}}</td>
                                                    <td :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}'>{{chequePayments.IsConfirm}} </td>
                                                    <td :style='{"background-color" : chequePayments.IsConfirmed == true ? "rgba(97, 153, 76, .3)" : ""}'>{{chequePayments.AdminComment}}</td>

                                                    <td width="250">
                                                        <button v-if="order.CollaegueOrderStatusTypeId == 2" @click="deleteChequePayment(chequePayments.Id ,chequePayments.OrderId )" style="margin-top:0 ;margin-left:15px" class="btn btn-danger btn-sm btn-reject">حذف</button>
                                                        <button v-if="chequePayments.PicPath != null" @click="showPicPathOrderPayment(chequePayments.PicPath)" style="margin-top:0" class="btn btn-success btn-sm">مشاهده تصویر</button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>

                            <add-CashPayment-modal></add-CashPayment-modal>
                            <add-ChequePayment-modal></add-ChequePayment-modal>
                            <show-PicPath-OrderPayment-Modal :urlImage="urlImageOrderPayment"></show-PicPath-OrderPayment-Modal>
                        </div>
                    </div>
                </div>

            </main>

            <footer-component></footer-component>
            <footer-fixnav-component></footer-fixnav-component>
        </div>
    </div>
</template>

<script>
    import { initialSite } from "../../module/initialSite"
    import { httpPromise } from "../../module/httpUtility";
    import addCashPaymentModal from "./addCashPaymentModal.vue";
    import addChequePaymentModal from "./addChequePaymentModal.vue";
    import showPicPathOrderPaymentModal from "./showPicPathOrderPaymentModal.vue";
    import { cashPaymentChangedEventBus, chequePaymentChangedEventBus } from "../../eventBus/eventBus";

    export default {
        data() {
            return {
                order: {},
                showLoader: false,
                cashPaymentInfo: {},
                isSendingDataToServer: false,
                urlImageOrderPayment: null,
            }
        },
        components: {
            'add-CashPayment-modal': addCashPaymentModal,
            'add-ChequePayment-modal': addChequePaymentModal,
            'show-PicPath-OrderPayment-Modal': showPicPathOrderPaymentModal
        },
        beforeMount() {
            createPageTitle('وضیعت سفارش');
            initialSite(this);
            this.isSendingDataToServer = true;
            this.readOrders();
        },
        methods: {
            readOrders() {
                httpPromise(this, '/v1/Orders/Orders/Read', 'Get', { HashOrderId: this.$route.params.hashOrderId },
                    response => {
                        toastr.remove();
                        this.order = response.data.Value;
                        this.isSendingDataToServer = false;
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isSendingDataToServer = false;
                    }
                );
            },
            openaddCashPaymentModal() {
                $(function () {
                    $('#addCashPaymentModal').modal({ backdrop: 'static', keyboard: false });
                    $('#addCashPaymentModal').modal('show');
                });
            },
            openaddChequePaymentModal() {
                $(function () {
                    $('#addChequePaymentModal').modal({ backdrop: 'static', keyboard: false });
                    $('#addChequePaymentModal').modal('show');
                });
            },
            showPicPathOrderPayment(url) {
                this.urlImageOrderPayment = url;
                console.log(this.urlImageOrderPayment);
                $(function () {
                    $('#showPicPathOrderPaymentModal').modal({ backdrop: 'static', keyboard: false });
                    $('#showPicPathOrderPaymentModal').modal('show');
                });
            },
            deleteCachPayment(cachPaymentId, orderId) {
                if (confirm("آیا از حذف این رکورد اطمینان دارید ؟")) {
                    this.isShowSppiner = true;
                    httpPromise(this, '/v1/Orders/ColleagueOrderCachPayments/Delete', 'delete', { CachPaymentId: cachPaymentId, OrderId: orderId },
                        response => {
                            toastr.remove();
                            toastr.success(response.data.Message);
                            this.isShowSppiner = false;
                            this.readOrders();
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                }
            },
            deleteChequePayment(chequePaymentId, orderId) {
                if (confirm("آیا از حذف این رکورد اطمینان دارید ؟")) {
                    this.isShowSppiner = true;
                    httpPromise(this, '/v1/Orders/ColleagueOrderChequePayments/Delete', 'delete', { ChequePaymentId: chequePaymentId, OrderId: orderId },
                        response => {
                            toastr.remove();
                            toastr.success(response.data.Message);
                            this.isShowSppiner = false;
                            this.readOrders();
                        },
                        response => {
                            toastr.remove();
                            toastr.error(response.data.Message);
                            this.isShowSppiner = false;
                        });
                }
            },
        },
        created: function () {
            cashPaymentChangedEventBus.$on('readOrdersMethod', () => {
                this.readOrders();
            });
            chequePaymentChangedEventBus.$on('readOrdersMethod', () => {
                this.readOrders();
            });
        },
    }
</script>
<style scoped>
    .cach-cheque .dk-btn-danger {
        background-color: #6f6d8f;
    }

    .cach-cheque .dk-btn::before {
        width: 27%;
    }

    .cach-cheque {
        padding: 10px;
    }

        .cach-cheque .parent-btn {
            margin-bottom: 15px;
        }

        .cach-cheque .dk-btn {
            font-size: 15px;
            padding: 10px 28px;
        }

            .cach-cheque .dk-btn > i {
                font-size: 15px;
                right: 7px;
                top: 15px;
                font-weight: bold;
            }

    .title-showInvoice {
        margin-bottom: 50px;
    }

    .preparreduration-main .content {
        display: inline-block;
        padding: 7px 25px 7px 25px;
        border: 1px solid #ddd;
        border-radius: 7px;
        margin-top: 25px;
        margin-bottom: 30px;
    }

    .preparreduration-text {
    }

    .alarm {
        font-size: 17px;
    }

    .toman {
        text-align: center;
        margin-bottom: 7px;
    }

        .toman i {
            vertical-align: middle;
            font-size: 17px;
        }

    .main-cartsummery {
        border: 1px solid #ddd;
        border-radius: 7px;
        margin-bottom: 25px;
        padding: 15px
    }

    .info-main-b {
        padding: 10px;
    }

        .info-main-b .text {
            color: #888;
        }

        .info-main-b .title {
            color: #666;
            font-size: 15px;
        }

    .info-main-top .text {
        color: #888;
    }

    .title-showInvoice {
        padding-right: 15px;
    }

    .info-main-top {
        padding: 25px;
        text-align: center;
    }

    .table thead tr {
        background-color: #85b3be;
        border: 1px solid #85b3be;
        color: #fff;
    }

    .shopping-page header.header-shopping .checkout-steps li a {
        display: inline-block;
        height: 39px;
    }

    .cart-page .checkout-aside {
        margin-top: 20px;
        margin-bottom: 83px;
        background-color: #fff;
    }

    .cart-page-content {
        background-color: #fff;
        margin-top: 20px;
    }

    .content-p {
        text-align: center;
    }

    .done {
    }

    .step1 {
    }

    .tracking {
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .tracking ul li .icon {
            display: block;
            height: 50px;
            width: 70px;
            margin: 0 auto;
            position: relative;
            padding: 0 10px;
            z-index: 100;
        }

        .tracking ul li {
            display: inline-table;
            width: 12%;
            position: relative;
            z-index: 1;
        }

            .tracking ul li.progress {
                border-top: 2px solid #cecece;
                border-top-color: rgb(206, 206, 206);
                border-radius: 0;
                background-color: #fff;
                height: 35px;
                width: 10%;
                margin-top: 30px;
            }

                .tracking ul li.progress.done {
                    border-color: #12b65c;
                }

            .tracking ul li.step1.done .icon {
                background: #fff url("/assets/img/step/track-step1h.svg") no-repeat center center;
            }

            .tracking ul li.step1 .icon {
                background: #fff url("/assets/img/step/track-step1.svg") no-repeat center center;
            }

            .tracking ul li.step2.done .icon {
                background: #fff url("/assets/img/step/track-step2h.svg") no-repeat center center;
            }

            .tracking ul li.step2 .icon {
                background: #fff url("/assets/img/step/track-step2.svg") no-repeat center center;
            }

            .tracking ul li.step3.done .icon {
                background: #fff url("/assets/img/step/track-step3h.svg") no-repeat center center;
            }

            .tracking ul li.step3 .icon {
                background: #fff url("/assets/img/step/track-step3.svg") no-repeat center center;
            }

            .tracking ul li.step4.done .icon {
                background: #fff url("/assets/img/step/track-step4h.svg") no-repeat center center;
            }

            .tracking ul li.step4 .icon {
                background: #fff url("/assets/img/step/track-step4.svg") no-repeat center center;
            }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .modal-open .modal {
            margin-bottom: 50px;
        }

        .success-checkout h1, .warning-checkout h1, .preparreduration-main .content {
            font-size: 12px;
        }

        .shopping-page header.header-shopping .checkout-steps li a.active::after {
            bottom: -23px;
        }

        .tracking ul li.progress {
            display: none;
            visibility: hidden;
        }

        .right-r {
            padding-right: 20px;
        }

        .left-l {
            padding-left: 20px;
        }

        .tracking {
            margin-top: 65px;
            margin-bottom: 70px;
        }
    }
</style>